module.exports = __webpack_public_path__ + "img/banner2.e6b6c71c.png";